import { css, SxProps, Theme } from "@mui/material";

export const textEllipsis = css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: clip;
  word-break: break-all;
`;

export const inlineFileTypeSelectSx: SxProps<Theme> = {
  width: "260px",
  mr: 3,
  textAlign: "right",
  position: "relative",
  "& .MuiFormHelperText-root": {
    position: "absolute",
    bottom: "-20px",
    left: 0,
    right: 0,
  },
};
